import { lazy } from 'react';

import { RouterSuspense } from '@/lib';

export const ReportsListAsync = RouterSuspense(
  lazy(() => import('./index.tsx')),
);
